export const NOT_FIRST_VISIT_KEY = "isNotFirstVisit";



// WEBPACK FOOTER //
// ../~/tslint-loader!./scripts/constants/not-first-visit-key.ts